export const LinkTypes = {
    ACTIVATION: 'activation',
    SET_PASSWORD: 'set_password',
    MEMBER_INVITATION: 'member_invitation',
    COMPANY_INVITATION: 'company_invitation',
    SHARED_ENTITY_INVITATION: 'external_entity_share',
    VISIBILITY_INSTANCE: 'visibility_instance',
};
